





































import BaseComponent from '@/components/base-component.vue';
import { AlterDadosBasicPrescrParmDTO } from '@/interfaces/prescription';
import { getClientUnitPrescription, updateBasicPrescriptionInfos } from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { InfosHelper } from './infos-helper';

@Component({
  components: {},
  directives: {}
})
export default class BasicInfosPrescriptionFormDialog extends BaseComponent {
  @Prop()
  item: any;

  unidade: any;

  formOpen = false;

  registro = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false
  };

  public rules: any = {
    registro: [(v) => this.validRegistro(v)]
  };

  regexpRegistro = null;

  validRegistro(v: string) {
    return InfosHelper.validRegistro(v, this.unidade, this.regexpRegistro);
  }

  @Watch('item.unidade', { immediate: true })
  onUnidadeChange(uni) {
    if (!uni || !uni.id) {
      return;
    }

    getClientUnitPrescription(uni.id).subscribe((res) => {
      this.unidade = res;
      this.regexpRegistro = InfosHelper.buildRegExpValidRegistro(this.unidade);
      this.$refs.form.validate();
    });
  }

  @Watch('item.registro', { immediate: true })
  onRegistroItemChange(reg) {
    this.registro = reg;
  }

  mounted() {
    this.formOpen = true;

    setTimeout(() => {
      this.$refs['tf_registro'].focus();
    }, 300);
  }

  public salvar(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    let parm = new AlterDadosBasicPrescrParmDTO();
    parm.idPrescricao = this.item.idPrescricao;
    parm.registro = this.registro;

    this.loader.start('Processando...');
    updateBasicPrescriptionInfos(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.toast.show(res, 'success');
        this.$emit('save', parm);
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  closeForm() {
    this.$emit('cancel');
  }
}
